import iphone from "../../assets/images/feature-iphone.png";
import {
  DevicePhoneMobileIcon,
  DocumentTextIcon,
  RocketLaunchIcon,
} from "@heroicons/react/24/outline";

const About = () => {
  return (
    <section id="about" className="py-20">
      <div className="container">
        <div className="grid lg:grid-cols-2 items-center gap-6">
          <div className="lg:ms-5 ms-8">
            <div>
              <span className="text-sm text-primary uppercase font-semibold tracking-wider text-default-950">
                What Sets Us Apart?
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl/tight font-semibold text-black mt-4">
              Asureis isn’t just another CRM
            </h2>
            <p className="text-base font-normal text-muted mt-6">
              We are redefining how ACA health insurance agents manage their
              business.
            </p>
            <div className="grid lg:grid-cols-3 grid-cols-1 gap-8 mt-9">
              <div className="">
                <div className="flex items-center justify-start">
                  <div className="items-center justify-center flex bg-green-50 rounded-full h-20 w-20 border border-dashed border-green-50">
                    <DevicePhoneMobileIcon className="h-8 w-8 text-black" />
                  </div>
                </div>
                <h1 className="text-xl font-semibold pt-6">
                  Built for ACA Agents, by ACA Agents{" "}
                </h1>
                <p className="text-base text-gray-600 font-normal mt-2">
                  We understand your pain points because we’ve been there. Our
                  system is designed with real-world agent experience in mind.
                </p>
              </div>
              <div className="">
                <div className="flex items-center justify-start">
                  <div className="items-center justify-center flex bg-red-50 rounded-full h-20 w-20 border border-dashed border-red-50">
                    <DocumentTextIcon className="h-8 w-8 text-black" />
                  </div>
                </div>
                <h1 className="text-xl font-semibold  pt-6">
                  Commission & Payment Reconciliation{" "}
                </h1>
                <p className="text-base text-gray-600 font-normal mt-2">
                  Unlike other CRMs, we don’t just track policies—we help you
                  ensure you get paid by identifying unpaid policies and
                  generating reports for carriers.
                </p>
              </div>
              <div className="">
                <div className="flex items-center justify-start">
                  <div className="items-center justify-center flex bg-primary/10 rounded-full h-20 w-20 border border-dashed border-primary/10">
                    <RocketLaunchIcon className="h-8 w-8 text-black" />
                  </div>
                </div>
                <h1 className="text-xl font-semibold pt-6">
                  Full Automation & Lead Management{" "}
                </h1>
                <p className="text-base text-gray-600 font-normal mt-2">
                  Spend less time on manual tasks and more time closing deals
                  with our built-in automation.
                </p>
              </div>
            </div>
            <div className="grid lg:grid-cols-3 grid-cols-1 gap-8 mt-9">
              <div className="">
                <div className="flex items-center justify-start">
                  <div className="items-center justify-center flex bg-green-50 rounded-full h-20 w-20 border border-dashed border-green-50">
                    <DevicePhoneMobileIcon className="h-8 w-8 text-black" />
                  </div>
                </div>
                <h1 className="text-xl font-semibold pt-6">
                  Seamless Zapier Integrations{" "}
                </h1>
                <p className="text-base text-gray-600 font-normal mt-2">
                  Connect Asureis with hundreds of tools you already use to
                  create a fully customized workflow.
                </p>
              </div>
              <div className="">
                <div className="flex items-center justify-start">
                  <div className="items-center justify-center flex bg-red-50 rounded-full h-20 w-20 border border-dashed border-red-50">
                    <DocumentTextIcon className="h-8 w-8 text-black" />
                  </div>
                </div>
                <h1 className="text-xl font-semibold  pt-6">
                  Compliance & Policy Tracking
                </h1>
                <p className="text-base text-gray-600 font-normal mt-2">
                  Stay compliant with ACA regulations while keeping track of
                  policy renewals and client follow-ups effortlessly.
                </p>
              </div>
              <div className="">
                <div className="flex items-center justify-start">
                  <div className="items-center justify-center flex bg-primary/10 rounded-full h-20 w-20 border border-dashed border-primary/10">
                    <RocketLaunchIcon className="h-8 w-8 text-black" />
                  </div>
                </div>
                <h1 className="text-xl font-semibold pt-6">
                  Designed for Growth{" "}
                </h1>
                <p className="text-base text-gray-600 font-normal mt-2">
                  Whether you're a solo agent or managing a team, Asureis scales
                  with your business needs.
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-center">
            <img
              src={iphone}
              className="h-[600px] rounded-xl mx-auto"
              alt="feature-image"
              width={538}
              height={600}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
